<div class="company-slide-out-drill-down">
  <div class="row">
    <div class="col-12 mb-3 drill-down-sticky">
      <span class="drill-down-company-name">
        {{ companyName$ | async }}
      </span>
      <sup class="drill-down-database-name" *ngIf="showDatabaseName"> ({{ databaseName }}) </sup>
      <div *ngIf="comparableIdByPageAndIndex && !navigationDisabled" class="drill-down-navigation">
        <button (click)="prev()" [disabled]="isPrevDisabled" class="drill-down-navigation-btn drill-down-navigation-btn-left">
          <i class="ey-menu-icon material-icons">chevron_left</i>
        </button>
        <button (click)="next()" [disabled]="isNextDisabled" class="drill-down-navigation-btn">
          <i class="ey-menu-icon material-icons">chevron_right</i>
        </button>
      </div>
    </div>
    <div class="col-12 mb-3">
      <app-drill-down-company-info></app-drill-down-company-info>
    </div>
    <div class="col-12 mb-3">
      <app-drill-down-business-description></app-drill-down-business-description>
    </div>
    <div class="col-12 mb-3">
      <app-drill-down-industry-descriptions></app-drill-down-industry-descriptions>
    </div>
    <div class="col-12 mb-3">
      <app-drill-down-financials></app-drill-down-financials>
    </div>
    <div class="col-12 mb-3">
      <app-drill-down-share-holders></app-drill-down-share-holders>
    </div>
    <div class="col-12 mb-3">
      <app-drill-down-subsidiaries></app-drill-down-subsidiaries>
    </div>
  </div>
</div>
